exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/* Shadows are intentionally very subtle gradiations. */\n.Center-Center_2CFna {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center; }\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/Center/Center.scss"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,qBAAqB;EACrB,cAAc;EACd,sBAAsB;MAClB,wBAAwB;EAC5B,uBAAuB;MACnB,oBAAoB,EAAE","file":"Center.scss","sourcesContent":["/* Shadows are intentionally very subtle gradiations. */\n.Center {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"Center": "Center-Center_2CFna"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]-[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./src/assets/scss/base.scss","./src/assets/scss/helpers.scss"]}!./src/components/Center/Center.scss
// module id = 1279
// module chunks = 0